import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import {
    APP_DISPLAY_NAME,
    getPatientRoomEntry,
    isRunningAsInstalledPwa,
    tryRedirectToSavedPatientRoom,
} from '../utils/patientRoomAccess';

/**
 * Home Screen / reopen entry.
 * Always opens the last scanned bed URL when one is saved.
 */
const PatientHome = ({ history }) => {
    const [missing, setMissing] = useState(false);

    useEffect(() => {
        // Hard redirect first (survives flaky router timing)
        if (tryRedirectToSavedPatientRoom()) {
            return undefined;
        }
        const saved = getPatientRoomEntry();
        if (saved) {
            history.replace(saved);
            return undefined;
        }
        setMissing(true);
        return undefined;
    }, [history]);

    if (!missing) {
        return (
            <div className="helpnow-patient-home">
                <img src="/logo192.png" alt={APP_DISPLAY_NAME} className="helpnow-patient-home-logo" />
                <p className="helpnow-patient-home-status">Opening your room…</p>
            </div>
        );
    }

    return (
        <div className="helpnow-patient-home">
            <img src="/logo192.png" alt={APP_DISPLAY_NAME} className="helpnow-patient-home-logo" />
            <h1>{APP_DISPLAY_NAME}</h1>
            <p>
                {isRunningAsInstalledPwa()
                    ? 'Scan your bedside QR code once to link this phone. After that, this icon opens your nurse call.'
                    : 'Please scan the QR code on your bedside to start. Add to Home Screen so this room opens again after you close the browser.'}
            </p>
            <p className="helpnow-patient-home-hint">Need help? Ask your nurse.</p>
        </div>
    );
};

export default withRouter(PatientHome);
